import { Flex, Steps, theme, Typography } from "antd"
import { CheckOutlined } from "@ant-design/icons"

import { useBreakpoint } from "@src/shared/hooks/useBreakpoints"
import css from "./index.module.css"

type Props = {
  step: number
}
export const RegistrationHeader = ({ step }: Props) => {
  const { token } = theme.useToken()
  const { smallerThanLg } = useBreakpoint()
  const REGISTRATION_FORM_STEPS = [
    {
      icon: (
        <div
          className={css.stepIcon}
          style={{
            backgroundColor: token.Table?.headerBg,
            border: `1px solid ${token.colorPrimary}`,
          }}
        >
          <CheckOutlined className={css.stepIconSuccess} />
        </div>
      ),
      title: null,
    },
    {
      icon: (
        <div
          className={css.stepIcon}
          style={{
            backgroundColor: token.Table?.headerBg,
            border: `1px solid ${token.colorPrimary}`,
          }}
        >
          <CheckOutlined className={css.stepIconSuccess} />
        </div>
      ),
      title: null,
    },
  ]

  return (
    <Flex align="flex-end" justify={smallerThanLg ? "center" : "space-between"}>
      <Typography.Title className={css.authTypography} style={{ margin: 0 }}>
        Sign Up
      </Typography.Title>

      {!smallerThanLg && (
        <Steps
          className={css.steps}
          current={step}
          direction="horizontal"
          items={REGISTRATION_FORM_STEPS}
          size="small"
          style={{ width: 100 }}
        />
      )}
    </Flex>
  )
}
